(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.SetPasswordController = (function(superClass) {
    extend(SetPasswordController, superClass);

    function SetPasswordController(scope, transitions, state, stateParams, http, q, service, auth_response, Routing, Session) {
      var jsr;
      this.scope = scope;
      this.transitions = transitions;
      this.state = state;
      this.stateParams = stateParams;
      this.http = http;
      this.q = q;
      this.service = service;
      this.Routing = Routing;
      this.Session = Session;
      this.login = bind(this.login, this);
      this.save = bind(this.save, this);
      this.cancel = bind(this.cancel, this);
      SetPasswordController.__super__.constructor.apply(this, arguments);
      jsr = auth_response.data;
      this.service.isCargillUser(this.stateParams.authentication_code).then((function(_this) {
        return function(isCargillUser) {
          return _this.scope.isCargillUser = isCargillUser;
        };
      })(this));
      this.Session.remove('Authorization');
      this.Session.remove('OriginalUser');
      this.Session.remove('AuthTime');
      this.Session.remove('SelectedCompany-grower');
      this.Session.remove('SelectedCompany-portal');
      this.Session.remove('SelectedCompany-admin');
      this.scope.auth_code = this.stateParams.authentication_code;
      this.scope.data_token = this.stateParams.data_token;
      this.scope.is_password_reset = this.stateParams.is_password_reset === '1';
      this.scope.password_confirm = null;
      this.scope.password = null;
      this.scope.auth_verify = null;
      this.scope.policy = false;
      this.scope.error = false;
      this.scope.save = this.save;
      this.scope.cancel = this.cancel;
      if (jsr.status.type === 'error') {
        this.scope.error = true;
      } else {
        this.scope.email = jsr.data.email;
        this.scope.username = jsr.data.username;
        this.scope.needs_verification = jsr.data.needs_verification;
      }
    }

    SetPasswordController.prototype.cancel = function() {
      return this.state.go('logout');
    };

    SetPasswordController.prototype.save = function() {
      return this.service.save(this.scope).then((function(_this) {
        return function(response) {
          var pretending;
          pretending = response.config.headers.PretendValidate;
          if (!pretending) {
            _this.setAlert(response.data.status, [], 2000);
            return setTimeout(function() {
              return _this.login();
            }, 2000);
          }
        };
      })(this));
    };

    SetPasswordController.prototype.login = function() {
      return this.http.post((Config.get('api_url')) + "/auth", {
        identifier: this.scope.email,
        password: this.scope.password
      }).then((function(_this) {
        return function(response) {
          var token;
          token = response.data.token;
          _this.Session.set('Authorization', "Bearer " + token);
          _this.Session.set('SafeLink', "Bearer " + token);
          _this.Session.set('OriginalUser', "Bearer " + token);
          _this.Session.set('AuthTime', new Date().getTime());
          _this.http.get((Config.get('api_url')) + "/me").then(function(response) {
            if (typeof Raven !== "undefined" && Raven !== null) {
              Raven.setUserContext(response.data);
            }
            return Socket.whenopen(function() {
              var ref;
              return (ref = Socket.socket) != null ? ref.send(response.data.id) : void 0;
            });
          });
          _this.Routing.determineDestination(_this.stateParams);
          return response;
        };
      })(this))["catch"]((function(_this) {
        return function(err) {
          var ref, ref1;
          _this.setAlert({
            type: 'error',
            msg: (ref = (ref1 = err.data) != null ? ref1.error : void 0) != null ? ref : 'Invalid Credentials'
          });
          return _this.q.reject(err);
        };
      })(this));
    };

    return SetPasswordController;

  })(Controller);

}).call(this);
